<template>
<div class="tw-text-sm font-normal">
  <a class="tw-link" :href="`tel:${ normalizeValue({number: storeAnswer.data.number, extension: storeAnswer.data.extension}) }`">
    {{ presentationValue(storeAnswer.data.number) }}
    {{ storeAnswer.data.extension ? 'ext. ' + storeAnswer.data.extension : '' }}
  </a>
</div>
</template>
<script>
import mixin from './_mixin_display'
import {presentationValue, normalizeValue} from './phone_number_field_edit.vue';
export default {
  mixins: [mixin],
  methods: {
    presentationValue,
    normalizeValue,
  }
}
</script>